import React from 'react';
import { motion } from 'framer-motion';

import { cn } from '../../lib/utils';

// Create properly typed motion components
const MotionDiv = motion.div;

interface StatItemProps {
  value: string;
  label: string;
  icon?: React.ReactNode;
  delay?: number;
}

function StatItem({ value, label, icon, delay = 0 }: StatItemProps) {
  return (
    <MotionDiv
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl shadow-xl border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-1"
    >
      {icon && <div className="mb-4 text-blue-300 flex justify-center">{icon}</div>}
      <div className="text-4xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-200 to-white">{value}</div>
      <div className="text-blue-100 font-medium">{label}</div>
    </MotionDiv>
  );
}

interface StatsProps {
  className?: string;
  items: Array<{
    value: string;
    label: string;
    icon?: React.ReactNode;
  }>;
}

export function Stats({ className, items }: StatsProps) {
  return (
    <div className={cn("max-w-5xl mx-auto", className)}>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((item, index) => (
          <StatItem
            key={index}
            value={item.value}
            label={item.label}
            icon={item.icon}
            delay={index * 0.1}
          />
        ))}
      </div>
    </div>
  );
}


